import React, { useState } from 'react';
import { Container, Typography, TextField, Button, Grid, Box } from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import emailjs from 'emailjs-com';  // Import EmailJS

function Contact() {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  // State for form data
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
  });

  // Handle form input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();

    // Send form data to EmailJS
    emailjs.send(
      'service_4cn0hhq', // Replace with your EmailJS service ID
      'template_7mkxajl', // Replace with your EmailJS template ID
      formData,
      'aA13HK1Kuf1g0RIO0'      // Replace with your EmailJS user ID
    )
    .then((response) => {
      alert('Message successfully sent!');
      console.log('SUCCESS!', response.status, response.text);
    })
    .catch((err) => {
      alert('Failed to send the message, please try again.');
      console.error('FAILED...', err);
    });

    // Clear form fields
    setFormData({ name: '', email: '', subject: '', message: '' });
  };

  return (
    <Container
      maxWidth="lg"
      style={{
        marginTop: '3rem',
        marginBottom: '3rem',
        backgroundColor: theme.palette.mode === 'dark' ? '#333' : '#fff',
        padding: '2rem',
        borderRadius: '8px',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
      }}
    >
      <Typography
        variant={isSmallScreen ? 'h5' : 'h4'}
        align="center"
        gutterBottom
        style={{ fontWeight: 'bold', marginBottom: '1.5rem' }}
      >
        Contact Us
      </Typography>
      <Typography variant="body1" align="center" gutterBottom>
        Have any questions or ready to discuss your financial goals? Contact us today, and our team will be happy to assist you.
      </Typography>

      <Grid container spacing={4} style={{ marginTop: '2rem' }}>
        <Grid item xs={12} md={4}>
          {/* Contact Information */}

          <Box style={{ marginBottom: '1.5rem', display: 'flex', alignItems: 'center' }}>
            <LocationOnIcon style={{ marginRight: '0.5rem', color: '#fdaa01' }} />
            <div>
              <Typography variant="h6" gutterBottom>
                Address
              </Typography>
              <Typography variant="body1">
              Harambee Avenue,Agip House, 6th Floor
                <br />
                <strong>Business Hours:</strong>
                <br />
                Monday - Friday: 9 AM - 6 PM
                <br />
                Saturday: 10 AM - 4 PM
                <br />
                Sunday: Closed
              </Typography>
            </div>
          </Box>

          <Box style={{ marginBottom: '1.5rem', display: 'flex', alignItems: 'center' }}>
            <PhoneIcon style={{ marginRight: '0.5rem', color: '#fdaa01' }} />
            <div>
              <Typography variant="h6" gutterBottom>
                Call Us
              </Typography>
              <Typography variant="body1">+254 719269649</Typography>
            </div>
          </Box>

          <Box style={{ display: 'flex', alignItems: 'center' }}>
            <EmailIcon style={{ marginRight: '0.5rem', color: '#fdaa01' }} />
            <div>
              <Typography variant="h6" gutterBottom>
                Email Us
              </Typography>
              <Typography variant="body1">info@fincalbusiness.co.ke</Typography>
            </div>
          </Box>

        </Grid>

        <Grid item xs={12} md={8}>
          {/* Contact Form */}
          <form onSubmit={handleSubmit}>
            <TextField
              fullWidth
              label="Your Name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              margin="normal"
              required
              variant="outlined"
              InputProps={{
                style: {
                  backgroundColor: theme.palette.mode === 'dark' ? '#444' : '#f7f7f7',
                  color: theme.palette.text.primary,
                },
              }}
            />
            <TextField
              fullWidth
              label="Your Email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              margin="normal"
              required
              type="email"
              variant="outlined"
              InputProps={{
                style: {
                  backgroundColor: theme.palette.mode === 'dark' ? '#444' : '#f7f7f7',
                  color: theme.palette.text.primary,
                },
              }}
            />
            <TextField
              fullWidth
              label="Subject"
              name="subject"
              value={formData.subject}
              onChange={handleChange}
              margin="normal"
              required
              variant="outlined"
              InputProps={{
                style: {
                  backgroundColor: theme.palette.mode === 'dark' ? '#444' : '#f7f7f7',
                  color: theme.palette.text.primary,
                },
              }}
            />
            <TextField
              fullWidth
              label="Message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              margin="normal"
              multiline
              rows={4}
              required
              variant="outlined"
              InputProps={{
                style: {
                  backgroundColor: theme.palette.mode === 'dark' ? '#444' : '#f7f7f7',
                  color: theme.palette.text.primary,
                },
              }}
            />
            <Button
              variant="contained"
              color="warning"
              fullWidth
              style={{ marginTop: '1.5rem', padding: '0.75rem', fontSize: '1rem', fontWeight: 'bold' }}
              type="submit"
            >
              Send Message
            </Button>
          </form>
        </Grid>
      </Grid>
    </Container>
  );
}

export default Contact;
